import {wupoServerUri} from '../Api';

const createWarehouseLabel = async(requestObject, jwtToken) => {
  

    // console.log(requestObject);
  
    const response = await fetch(`${wupoServerUri.devnet}/api/secure/newlabel`, {
        method: "POST",
        body: JSON.stringify(requestObject),
        credentials: 'include',
        headers: {
          "Authorization": `Bearer ${jwtToken}`,
          "Content-Type": "application/json; charset=UTF-8",
        },
    })
    .catch((error) => {
      // console.log("Error: " + error);
    });
  
    // console.log(response.status);
    if(response.status === 200 ){

      const qrResponse = await response.json();
        // console.log(qrResponse);

        const byteImage = Buffer.from(qrResponse.qrImageBytes, 'base64');
        qrResponse.qrImageBytes = new Blob([byteImage], {type: "application/octet-stream"});
        

        // const qrImg = new Blob([qrResponse], { type: 'image/png'});

        return qrResponse;
    }
  
    else {
      return null;
    }
};

const discardProductBatch = async(requestObject, jwtToken) => {
  

  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/discardlabel`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){

    const discardBatch = await response.json();
      // console.log(discardBatch);

      return discardBatch;
  }

  else {
    return null;
  }
};

const getWarehouseCodes = async(jwtToken) => {
  

    // console.log(requestObject);
  
    const response = await fetch(`${wupoServerUri.devnet}/api/secure/warehouseCodes`, {
        method: "POST",
        // body: JSON.stringify(requestObject),
        credentials: 'include',
        headers: {
          "Authorization": `Bearer ${jwtToken}`,
        //   "Content-Type": "application/json; charset=UTF-8",
        },
    })
    .catch((error) => {
      console.log("Error: " + error);
    });
  
    // console.log(response.status);
    if(response.status === 200 ){
      const codes = await response.json();
      // console.log(codes);

  
      return codes;
    }
  
    else {
        return null;
    }
};

const getProductBatch = async(requestObject, jwtToken) => {
  
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/productBatch`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const productBatch = await response.json();
    console.log(productBatch);


    return productBatch;
  }

  else {
      return null;
  }
};

const getAllProductBatches = async(jwtToken) => {
  

  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/allProductBatch`, {
      method: "POST",
      // body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      //   "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const batches = await response.json();
    // console.log(batches);


    return batches;
  }

  else {
      return null;
  }
};

const getProductBatchPage = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/allProductBatchPage`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const productBatch = await response.json();
    // console.log(productBatch);


    return productBatch;
  }

  else {
      return null;
  }
};

const updateCheckpoint = async(requestObject, jwtToken) => {
  
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/warehouseCheckpoint`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  console.log(response.status);
  if(response.status === 200 ){
    const productBatch = await response.json();
    console.log(productBatch);


    return productBatch;
  }

  else if(response.status === 409 ){
    return response.status;
  }

  else {
      return null;
  }
};

const updateCediCheckpoint = async(requestObject, jwtToken) => {
  
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/cediCheckpoint`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const productBatch = await response.json();
    console.log(productBatch);


    return productBatch;
  }

  else {
      return null;
  }
};

const getActiveProductBatches = async(jwtToken) => {
  

  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/activeProductBatch`, {
      method: "POST",
      // body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      //   "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const batches = await response.json();
    // console.log(batches);


    return batches;
  }

  else {
      return null;
  }
};

const createNewPosition = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/registerPosition`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const productBatch = await response.json();
    // console.log(productBatch);


    return productBatch;
  }

  else {
      return null;
  }
};

const getInventory = async(jwtToken) => {
  

  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/warehouseInventoryGrouped`, {
      method: "POST",
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const products = await response.json();
    // console.log(products);


    return products;
  }

  else {
      return null;
  }
};

const getWarehouseProduct = async(requestObject, jwtToken) => {
  

  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/warehouseProduct`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const product = await response.json();
    // console.log(product);


    return product;
  }

  else {
      return null;
  }
};

const productBatchChange = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/batchChange`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const productBatch = await response.json();
    // console.log(productBatch);


    return productBatch;
  }

  else {
      return null;
  }
};

const createDeliveryOrder = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/warehouseOrder`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const delOrder = await response.json();
    // console.log(delOrder);


    return delOrder;
  }

  else {
      return null;
  }
};

const updateDeliveryOrder = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/warehouseOrderinput`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const delOrder = await response.json();
    // console.log(delOrder);


    return delOrder;
  }

  else {
      return null;
  }
};

const getOrdersReady = async(jwtToken) => {
  

  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/warehouseReadyOrders`, {
      method: "POST",
      // body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      //   "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const products = await response.json();
    // console.log(products);


    return products;
  }

  else {
      return null;
  }
};

const getOrdersReadyPage = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/warehouseReadyOrdersPage`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });
  
  if(!response){
    return null;
  }
    
  if(response.status === 200 ){
    const orders = await response.json();
    // console.log(orders);


    return orders;
  }

  else {
      return null;
  }
};

const getProductByDescription = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/warehouseOrderProducts`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const batches = await response.json();
    // console.log(batches);


    return batches;
  }

  else {
      return null;
  }
};

const getTransportProductByDescription = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/warehouseTransporOrderProducts`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const batches = await response.json();
    // console.log(batches);


    return batches;
  }

  else {
      return null;
  }
};

const enableBatchesForPickup = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/warehouseOrderPickup`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const order = await response.json();
    // console.log(order);


    return order;
  }

  else {
      return null;
  }
};

const particularOrderChange = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/particularOrderChange`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  console.log(response.status);
  if(response.status === 200 ){
    const batch = await response.json();
    // console.log(batch);


    return batch;
  }

  else {
      return null;
  }
};

const getAllTransportOrders = async(jwtToken) => {
  

  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/allTransportOrders`, {
      method: "POST",
      // body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      //   "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const orders = await response.json();
    // console.log(orders);


    return orders;
  }

  else {
      return null;
  }
};

const getAllRawTransportOrders = async(jwtToken) => {
  

  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/rawTransportOrders`, {
      method: "POST",
      // body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      //   "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const orders = await response.json();
    // console.log(orders);


    return orders;
  }

  else {
      return null;
  }
};

const getTransportOrderResponse = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/transportOrderResponse`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const order = await response.json();
    // console.log(order);

    return order;
  }

  else {
      return null;
  }
};

const getTransportOrder = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/transportOrder`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const order = await response.json();
    // console.log(order);

    return order;
  }

  else {
      return null;
  }
};

const closeTransportOrder = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/closeTransportOrder`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const order = await response.json();
    // console.log(order);

    return order;
  }

  else {
      return null;
  }
};

const newMasterProduct = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/newWarehouseProduct`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const product = await response.json();
    // console.log(product);

    return product;
  }

  else {
      return null;
  }
};

const changeTransportOrder = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/changeTransportOrder`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const order = await response.json();
    // console.log(order);

    return order;
  }

  else {
      return null;
  }
};

const disableForPickup = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/disableBatchForPickup`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const batch = await response.json();
    // console.log(batch);

    return batch;
  }

  else {
      return null;
  }
};

const manualEnableForPickup = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/manualWarehouseOrderPickup`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const body = await response.json();
    // console.log(body);

    return body;
  }

  else {
      return null;
  }
};

const changeIndividualsInOrder = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/manualOrderAmountChange`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const order = await response.json();
    // console.log(order);

    return order;
  }

  else {
      return null;
  }
};

const manualAssignmentToOrder = async(requestObject, jwtToken) => {
  
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/manualAssignmentToOrder`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const order = await response.json();
    // console.log(order);

    return order;
  }

  else {
      return null;
  }
};

const activateLabelBatch = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/activateLabelBatch`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const activateResponse = await response.json();
    // console.log(activateResponse);

    return activateResponse;
  }

  else {
      return null;
  }
};

const enableBatch = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/enableBatch`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);  
  if(response.status === 200 ){
    return true;
  }

  else {
      return false;
  }
};



const getOrderByCode = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/orderByCode`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const body = await response.json();
    // console.log(body);

    return body;
  }

  else {
      return null;
  }
};

const qryproductBatch = (jwtToken) => {

  return(
    fetch(`${wupoServerUri.devnet}/api/secure/productBatchTransportCsv`, {
        
        method: 'POST',
        // body: JSON.stringify(creditObject),
        headers: {
          'Authorization': `Bearer ${jwtToken}`, 
          'Content-Type': 'application/json'                     
        }
        
      }).then((response) => { 
        // console.log(response.status) // DEBUG PRINTING

        if(response.status === 200){
          // console.log(response.status);
          return response.blob();
        }
        else{
            return null;
        }
    
      }).then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = "reporte_estibas.csv";
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();    
          a.remove();  //afterwards we remove the element again      
          
          return "ok";
          
    }).catch(function(error){
        console.log("Error msg: "+ error);
    })
  );

};

const qryproductBatchAndIndividuals = (jwtToken) => {

  return(
    fetch(`${wupoServerUri.devnet}/api/secure/productBatchAndIndividualsTransportCsv`, {
        
        method: 'POST',
        // body: JSON.stringify(creditObject),
        headers: {
          'Authorization': `Bearer ${jwtToken}`, 
          'Content-Type': 'application/json'                     
        }
        
      }).then((response) => { 
        // console.log(response.status) // DEBUG PRINTING

        if(response.status === 200){
          // console.log(response.status);
          return response.blob();
        }
        else{
            return null;
        }
    
      }).then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = "reporte_estibas_e_individuales.csv";
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();    
          a.remove();  //afterwards we remove the element again      
          
          return "ok";
          
    }).catch(function(error){
        console.log("Error msg: "+ error);
    })
  );

};

const qryproductBatchCedi = (jwtToken) => {

  return(
    fetch(`${wupoServerUri.devnet}/api/secure/productBatchCediCsv`, {
        
        method: 'POST',
        // body: JSON.stringify(creditObject),
        headers: {
          'Authorization': `Bearer ${jwtToken}`, 
          'Content-Type': 'application/json'                     
        }
        
      }).then((response) => { 
        // console.log(response.status) // DEBUG PRINTING

        if(response.status === 200){
          // console.log(response.status);
          return response.blob();
        }
        else{
            return null;
        }
    
      }).then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = "reporte_estibas.csv";
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();    
          a.remove();  //afterwards we remove the element again      
          
          return "ok";
          
    }).catch(function(error){
        console.log("Error msg: "+ error);
    })
  );

};

const qryTotalInventory = (jwtToken) => {

  return(
    fetch(`${wupoServerUri.devnet}/api/secure/inventoryCsv`, {
        
        method: 'POST',
        // body: JSON.stringify(creditObject),
        headers: {
          'Authorization': `Bearer ${jwtToken}`, 
          'Content-Type': 'application/json'                     
        }
        
      }).then((response) => { 
        // console.log(response.status) // DEBUG PRINTING

        if(response.status === 200){
          // console.log(response.status);
          return response.blob();
        }
        else{
            return null;
        }
    
      }).then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = "inventoario_total.csv";
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();    
          a.remove();  //afterwards we remove the element again      
          
          return "ok";
          
    }).catch(function(error){
        console.log("Error msg: "+ error);
    })
  );

};

const qryDailyInventory = (jwtToken) => {

  return(
    fetch(`${wupoServerUri.devnet}/api/secure/dailyInventoryCsv`, {
        
        method: 'POST',
        // body: JSON.stringify(creditObject),
        headers: {
          'Authorization': `Bearer ${jwtToken}`, 
          'Content-Type': 'application/json'                     
        }
        
      }).then((response) => { 
        // console.log(response.status) // DEBUG PRINTING

        if(response.status === 200){
          // console.log(response.status);
          return response.blob();
        }
        else{
            return null;
        }
    
      }).then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = "inventoario_diario.csv";
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();    
          a.remove();  //afterwards we remove the element again      
          
          return "ok";
          
    }).catch(function(error){
        console.log("Error msg: "+ error);
    })
  );

};

const qryDefects = (jwtToken) => {

  return(
    fetch(`${wupoServerUri.devnet}/api/secure/defectCsv`, {
        
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${jwtToken}`, 
          'Content-Type': 'application/json'                     
        }
        
      }).then((response) => { 

        if(response.status === 200){
          return response.blob();
        }
        else{ 
            return null;
        }
        
      }).then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = "reporte_averias.csv";
          document.body.appendChild(a);
          a.click();
          a.remove();

          return "ok";
          
    }).catch(function(error){
        console.log("Error msg: "+ error);
    })
  );

};

const qryPicking = (jwtToken) => {

  return(
    fetch(`${wupoServerUri.devnet}/api/secure/pickingCsv`, {
        
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${jwtToken}`, 
          'Content-Type': 'application/json'
        }
        
      }).then((response) => { 

        if(response.status === 200){
          return response.blob();
        }
        else{
            return null;
        }
        
      }).then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = "reporte_picking.csv";
          document.body.appendChild(a);
          a.click();
          a.remove();

          return "ok";
          
    }).catch(function(error){
        console.log("Error msg: "+ error);
    })
  );

};

const qryBatchChanges = (jwtToken) => {

  return(
    fetch(`${wupoServerUri.devnet}/api/secure/batchChangesCsv`, {
        
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${jwtToken}`, 
          'Content-Type': 'application/json'
        }
        
      }).then((response) => { 

        if(response.status === 200){
          return response.blob();
        }
        else{
            return null;
        }
        
      }).then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = "reporte_cambios.csv";
          document.body.appendChild(a);
          a.click();
          a.remove();

          return "ok";
          
    }).catch(function(error){
        console.log("Error msg: "+ error);
    })
  );

};


const getActiveTransportOrdersIdentifiers = async(jwtToken) => {
  

  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/activeTransportOrderIdentifiers`, {
      method: "POST",
      // body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      //   "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const orders = await response.json();
    // console.log(orders);


    return orders;
  }

  else {
      return null;
  }
};

const manualBatchToTransportOrder = async(requestObject, jwtToken) => {
  
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/manualBatchToTransportOrder`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  console.log(response.status);
  if(response.status === 200 ){
    const order = await response.json();
    console.log(order);

    return order;
  }

  else {
      return null;
  }
};

const getAllCediOrder = async(jwtToken) => {
  

  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/allCediOrders`, {
      method: "POST",
      // body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      //   "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const object = await response.json();
    // console.log(orders);


    return object;
  }

  else {
      return null;
  }
};

const getOpenCediOrders = async(jwtToken) => {
  

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/openCediOrders`, {
      method: "POST",
      // body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      //   "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const object = await response.json();
    console.log(object);


    return object;
  }

  else {
      return null;
  }
};

const getClosedCediOrders = async(jwtToken) => {
  

  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/closedCediOrders`, {
      method: "POST",
      // body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      //   "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const object = await response.json();
    // console.log(orders);


    return object;
  }

  else {
      return null;
  }
};

const closeCediOrder = async(requestObject, jwtToken) => {
  
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/closeCediOrder`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const order = await response.json();
    // console.log(order);

    return order;
  }

  else {
      return null;
  }
};

const getCediOrder = async(requestObject, jwtToken) => {
  
  // console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/getCediOrder`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const order = await response.json();
    // console.log(order);

    return order;
  }

  else {
      return null;
  }
};

const getCediOrdersPage = async(requestObject, jwtToken) => {
  
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/allCediOrdersPage`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  // console.log(response.status);
  if(response.status === 200 ){
    const productBatch = await response.json();
    console.log(productBatch);


    return productBatch;
  }

  else {
      return null;
  }
};

const createCediOrder = async(requestObject, jwtToken) => {
  
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/createCediOrders`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  console.log(response.status);
  if(response.status === 200 ){
    const productBatch = await response.json();
    console.log(productBatch);


    return productBatch;
  }

  else {
      return null;
  }
};

const addBatchToCediOrder = async(requestObject, jwtToken) => {
  
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/addBatchToCediOrder`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200 ){
    const responseBody = await response.json();
    console.log(responseBody);

    return responseBody;
  }

  else {
      return null;
  }
};

const removeBatchFromCediOrder = async(requestObject, jwtToken) => {
  
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/removeBatchFromCediOrder`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200 ){
    const responseBody = await response.json();
    console.log(responseBody);

    return responseBody;
  }

  else {
      return null;
  }
};

const generateOrderCediExcelReport = (requestObject, jwtToken) => {

  console.log(requestObject);

  return(
    fetch(`${wupoServerUri.devnet}/api/secure/generateCediOrderReport`, {
        
        method: 'POST',
        body: JSON.stringify(requestObject),
        headers: {
          'Authorization': `Bearer ${jwtToken}`, 
          'Content-Type': 'application/json'                     
        }
        
      }).then((response) => { 
        // console.log(response.status) // DEBUG PRINTING

        if(response.status === 200){
          // console.log(response.status);
          return response.blob();
        }
        else{
            return null;
        }
    
      }).then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = "reporte.xlsx";
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();    
          a.remove();  //afterwards we remove the element again      
          
          return "ok";
          
    }).catch(function(error){
        console.log("Error msg: "+ error);
    })
  );

};

const getPendingBatches = async(jwtToken) => {

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/getPendingBatches`, {
    method: "POST",
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200 ){
    const batches = await response.json();
    return batches;
  }
  
  else {
      return null;
  }
};

const disableBatch = async(requestObject, jwtToken) => {

  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/disableBatch`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  });

  if(response.status === 200 ){
    const disabledBatch = await response.json();
    return disabledBatch;
  }

  else {
      return null;
  }

};

const createPickingOrder = async(requestObject, jwtToken) => {

  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/picking-order`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  });

  if(response.status === 200 ){
    const pickingOrder = await response.json();
    return pickingOrder;
  }

  else {
      return null;
  }

};

const uploadOrderFile = async(file, fileType, jwtToken) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('fileType', fileType);

  console.log(fileType);
  
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/uploadOrderFile`, {
    method: "POST",
    body: formData,
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      // Don't set Content-Type here, it will be set automatically with the boundary
    },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200) {
    const orders = await response.json();
    return orders;
  } else {
    return null;
  }
};

const getBatchIndividuals = async(batchId, jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/batchIndividuals`, {
    method: "POST",
    body: JSON.stringify({ batchId }),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  }).catch((error) => {
    console.log("Error: " + error);
  });

  if (response && response.status === 200) {
    return await response.json();
  }
  return null;
};

const getAllWarehouseProducts = async(jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/warehouseInventory`, {
    method: "POST",
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  }).catch((error) => {
    console.log("Error: " + error);
  });

  if (response && response.status === 200) {
    return await response.json();
  }
  return null;
};

const getProductBatchFiltered = async(requestObject, jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/allProductBatchFiltered`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  }).catch((error) => {
    console.log("Error: " + error);
  });

  if (response && response.status === 200) {
    return await response.json();
  }
  return null;
};

const getKpiSummary = async(requestObject, jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/delivery-orders/stats/kpi-summary`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  }).catch((error) => {
    console.log("Error: " + error);
  });

  if (response && response.status === 200) {
    return await response.json();
  }
  return null;
};

const getInventoryByProduct = async(jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/delivery-orders/stats/inventory-by-product`, {
    method: "POST",
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  }).catch((error) => {
    console.log("Error: " + error);
  });

  if (response && response.status === 200) {
    return await response.json();
  }
  return null;
};

const getDefectsByProduct = async(jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/delivery-orders/stats/defects-by-product`, {
    method: "POST",
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  }).catch((error) => {
    console.log("Error: " + error);
  });

  if (response && response.status === 200) {
    return await response.json();
  }
  return null;
};

const getDashboardSummary = async(jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/delivery-orders/stats/dashboard-summary`, {
    method: "POST", credentials: 'include',
    headers: { "Authorization": `Bearer ${jwtToken}`, "Content-Type": "application/json; charset=UTF-8" },
  }).catch((error) => { console.log("Error: " + error); });
  if (response && response.status === 200) return await response.json();
  return null;
};

const getInventoryExpiry = async(jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/delivery-orders/stats/inventory-expiry`, {
    method: "POST", credentials: 'include',
    headers: { "Authorization": `Bearer ${jwtToken}`, "Content-Type": "application/json; charset=UTF-8" },
  }).catch((error) => { console.log("Error: " + error); });
  if (response && response.status === 200) return await response.json();
  return null;
};

const getDefectsByMonthStats = async(requestObject, jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/delivery-orders/stats/defects-by-month`, {
    method: "POST", body: JSON.stringify(requestObject), credentials: 'include',
    headers: { "Authorization": `Bearer ${jwtToken}`, "Content-Type": "application/json; charset=UTF-8" },
  }).catch((error) => { console.log("Error: " + error); });
  if (response && response.status === 200) return await response.json();
  return null;
};

const getAllPickingOrders = async(jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/getAllPickingOrders`, {
    method: "POST",
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  });

  if(response.status === 200 ){
    const pickingOrders = await response.json();
    return pickingOrders;
  }

  else {
      return null;
  }
};

const getBatchDefects = async(jwtToken) => {
  try {
    const response = await fetch(`${wupoServerUri.devnet}/api/secure/getBatchDefects`, {
      method: "POST",
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
    });

    if(response.status === 200) {
      const batchDefects = await response.json();
      console.log(batchDefects);
      return batchDefects;
    } else {
      console.log("Error status:", response.status);
      return null;
    }
  } catch (error) {
    console.log("Error fetching batch defects:", error);
    return null;
  }
};

const getBatchDefectsPage = async(requestObject, jwtToken) => {
  try {
    const response = await fetch(`${wupoServerUri.devnet}/api/secure/getBatchDefectsPage`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
    });

    if(response.status === 200) {
      const batchDefectsPage = await response.json();
      console.log(batchDefectsPage);
      return batchDefectsPage;
    } else {
      console.log("Error status:", response.status);
      return null;
    }
  } catch (error) {
    console.log("Error fetching batch defects page:", error);
    return null;
  }
};

const getBatchDefectsByBatchCode = async(requestObject, jwtToken) => {
  try {
    const response = await fetch(`${wupoServerUri.devnet}/api/secure/getBatchDefectsByBatchCode`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
    });

    if(response.status === 200) {
      const batchDefectsPage = await response.json();
      console.log(batchDefectsPage);
      return batchDefectsPage;
    } else {
      console.log("Error status:", response.status);
      return null;
    }
  } catch (error) {
    console.log("Error fetching batch defects by batch code:", error);
    return null;
  }
};

const getAllUsernames = async(jwtToken) => {

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/getAllUsernames`, {
      method: "POST",
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  console.log(response.status);
  if(response.status === 200 ){
    const body = await response.json();
    console.log(body);

    return body;
  }

  else {
    return null;
  }
};

const getSingleUser = async(requestObject, jwtToken) => {
  
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/getSingleUser`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  console.log(response.status);
  if(response.status === 200 ){
    const body = await response.json();
    console.log(body);

    return body;
  }

  else {
    return null;
  }
};

const handleBlockUser = async(requestObject, jwtToken) => {
  
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/handleBlockUser`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  console.log(response.status);
  if(response.status === 200 ){
    const body = await response.json();
    console.log(body);

    return body;
  }

  else {
    return null;
  }
};

const deleteWellnessUser = async(requestObject, jwtToken) => {
  
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/deleteWellnessUser`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  console.log(response.status);
  if(response.status === 200 ){
    // const jsonResponse = await response.json();
    // console.log(jsonResponse);

    return "ok";
  }

  else {
    return null;
  }
};

const changePwd = async(requestObject, jwtToken) => {

  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/changePwd`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  });

  console.log(response.status);
  if(response.status === 200 ){
    const body = await response.json();
    // console.log(body);

    return body;
  }

  else {
    return null;
  }
};


const updateUserInfo = async(requestObject, jwtToken) => {

  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/updateUserInfo`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  });

  if(response.status === 200 ){
    const body = await response.json();
    console.log(body);

    return body;
  }

  else {
    return null;
  }
};

const getTransportOrdersPage = async(requestObject, jwtToken) => {
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/transportOrdersPage`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200) {
    const ordersPage = await response.json();
    console.log(ordersPage);
    return ordersPage;
  } else {
    return null;
  }
};

const getTransportOrdersByDatePage = async(requestObject, jwtToken) => {
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/transportOrdersByDatePage`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200) {
    const ordersPage = await response.json();
    console.log(ordersPage);
    return ordersPage;
  } else {
    return null;
  }
};

const getTransportOrdersByBatchCode = async(requestObject, jwtToken) => {
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/transportOrdersByBatchCode`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200) {
    const ordersPage = await response.json();
    console.log(ordersPage);
    return ordersPage;
  } else {
    return null;
  }
};

const getTransportOrdersByClientName = async(requestObject, jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/transportOrdersByClientName`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200) {
    const ordersPage = await response.json();
    return ordersPage;
  } else {
    return null;
  }
};

const searchBatchByCode = async(requestObject, jwtToken) => {
  // Only search if batchCode is at least 3 characters long
  if (!requestObject.batchCode || requestObject.batchCode.length < 3) {
    return { batchCodes: [] };
  }

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/searchBatchByCode`, {
      method: "POST",
      body: JSON.stringify(requestObject),
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200) {
    const result = await response.json();
    return result;
  } else {
    return { batchCodes: [] };
  }
};

const getDeliveriesByRegion = async(requestObject, jwtToken) => {
  console.log(requestObject);
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/delivery-orders/stats/by-region`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  })
  .catch((error) => {
    console.log("Error fetching region delivery data:", error);
  });

  if(response.status === 200) {
    const data = await response.json();
    console.log(data);
    return data;
  } else {
    return null;
  }
};

const getDeliveriesByTransporter = async(requestObject, jwtToken) => {

  console.log(requestObject);
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/delivery-orders/stats/by-transporter`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  })
  .catch((error) => {
    console.log("Error fetching transporter delivery data:", error);
  });

  if(response.status === 200) {
    const data = await response.json();
    console.log(data);
    console.log(JSON.stringify(data));
    return data;
  } else {
    return null;
  }
};

const getDeliveriesByClient = async(requestObject, jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/delivery-orders/stats/by-client`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  })
  .catch((error) => {
    console.log("Error fetching client delivery data:", error);
  });

  if(response.status === 200) {
    const data = await response.json();
    console.log(data);
    return data;
  } else {
    return null;
  }
};

const getDeliveriesByMonth = async(requestObject, jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/delivery-orders/stats/by-month`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  })
  .catch((error) => {
    console.log("Error fetching monthly delivery data:", error);
  });

  if(response.status === 200) {
    const data = await response.json();
    console.log(data);
    return data;
  } else {
    return null;
  }
};

const enablePickingStatus = async(requestObject, jwtToken) => {
  console.log(requestObject);
  
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/enablePickingStatus`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200) {
    const body = await response.json();
    console.log(body);
    return body;
  } else {
    return null;
  }
};

const disablePickingStatus = async(requestObject, jwtToken) => {
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/disablePickingStatus`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200) {
    const body = await response.json();
    console.log(body);
    return body;
  } else {
    return null;
  }
};

const batchChangeReport = async(jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/batchChangeReport`, {
    method: "POST",
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
    },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200) {
    const body = await response.json();
    console.log(body);
    return body;
  } else {
    return null;
  }
};

const createManualInventory = async(jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/manual-inventory/createManualInventory`, {
    method: "POST",
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200) {
    const body = await response.json();
    console.log(body);
    return body;
  } else {
    return null;
  }
};

const addNewEntryToManualInventory = async(requestObject, jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/manual-inventory/addNewEntry`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200) {
    const body = await response.json();
    console.log(body);
    return body;
  } else if (response.status === 409) {
    return "duplicated";
  }
  
  else {
    return null;
  }
};

const getAllManualInventories = async(jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/manual-inventory/getAllInventories`, {
    method: "POST",
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200) {
    const body = await response.json();
    console.log(body);
    return body;
  } else {
    return null;
  }
};

const getAllManualInventoriesPaged = async(requestObject, jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/manual-inventory/getAllInventoriesPaged`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200) {
    const body = await response.json();
    console.log(body);
    return body;
  } else {
    return null;
  }
};

const exportManualInventoryEntriesToCsv = (inventoryId, jwtToken) => {
    return new Promise((resolve, reject) => {
        const requestObject = {
            inventoryId: inventoryId
        };
        
        fetch(`${wupoServerUri.devnet}/api/secure/manualInventoryEntriesCsv`, {
            method: 'POST',
            body: JSON.stringify(requestObject),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`
            }
        })
        .then(response => {
            if (response.ok) {
                return response.blob();
            } else {
                throw new Error('Error downloading CSV');
            }
        })
        .then(blob => {
            // Create a link to download the blob
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `inventario_manual_${inventoryId}.csv`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            resolve(true);
        })
        .catch(error => {
            console.error('Error exporting manual inventory entries to CSV:', error);
            reject(error);
        });
    });
};

const getAllTransporters = async(jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/delivery-transporters/allTransporters`, {
    method: "POST",
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200) {
    const body = await response.json();
    console.log(body);
    return body;
  } else {
    return null;
  }
};

const getInventoryByBatchCode = async(requestObject, jwtToken) => {
  console.log(requestObject);

  const response = await fetch(`${wupoServerUri.devnet}/api/secure/inventoryByBatchCode`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  if(response.status === 200) {
    const data = await response.json();
    return data;
  } else {
    return null;
  }
};

const searchPendingOrders = async(requestObject, jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/searchPendingOrders`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  }).catch((error) => { console.log("Error: " + error); });
  if (response && response.status === 200) return await response.json();
  return null;
};

const removeOrderFromTransport = async(requestObject, jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/removeOrderFromTransport`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  }).catch((error) => { console.log("Error: " + error); });
  if (response && response.status === 200) return await response.json();
  return null;
};

const addOrderToTransport = async(requestObject, jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/addOrderToTransport`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  }).catch((error) => { console.log("Error: " + error); });
  if (response && response.status === 200) return await response.json();
  return null;
};

const changeBatchDefectsAmount = async(requestObject, jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/secure/changeBatchDefectsAmount`, {
    method: "POST",
    body: JSON.stringify(requestObject),
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  });

  if(response.status === 200) {
    const data = await response.json();
    return data;
  } else {
    return null;
  }
};

export { createWarehouseLabel, getWarehouseCodes, getProductBatch, updateCheckpoint, getAllProductBatches, 
  getActiveProductBatches, createNewPosition, discardProductBatch, getInventory, productBatchChange, createDeliveryOrder,
  updateDeliveryOrder, getOrdersReady, getProductByDescription, enableBatchesForPickup, particularOrderChange,
  getAllTransportOrders, getTransportOrder, closeTransportOrder, newMasterProduct, changeTransportOrder, disableForPickup,
  changeIndividualsInOrder, qryproductBatch, qryTotalInventory, qryDailyInventory, activateLabelBatch, getOrdersReadyPage,
  getProductBatchPage, getOrderByCode, manualEnableForPickup, getTransportProductByDescription,
  getActiveTransportOrdersIdentifiers, manualBatchToTransportOrder, manualAssignmentToOrder, getAllRawTransportOrders, 
  getTransportOrderResponse, getAllCediOrder, getOpenCediOrders, getClosedCediOrders, closeCediOrder, getCediOrder, 
  getCediOrdersPage, createCediOrder, updateCediCheckpoint, qryproductBatchCedi, addBatchToCediOrder,
  removeBatchFromCediOrder, generateOrderCediExcelReport, enableBatch, getPendingBatches, disableBatch, createPickingOrder,
  uploadOrderFile, getAllPickingOrders, getBatchDefects, getBatchDefectsPage, getBatchDefectsByBatchCode, getAllUsernames, 
  getSingleUser, handleBlockUser, deleteWellnessUser, changePwd, updateUserInfo, getTransportOrdersPage, getTransportOrdersByDatePage, 
  qryDefects, qryPicking, getDeliveriesByRegion, getDeliveriesByTransporter, getDeliveriesByClient, getDeliveriesByMonth, 
  enablePickingStatus, disablePickingStatus, batchChangeReport, createManualInventory, addNewEntryToManualInventory, 
  getAllManualInventories, getAllManualInventoriesPaged, exportManualInventoryEntriesToCsv, qryBatchChanges, getAllTransporters, 
  getInventoryByBatchCode, qryproductBatchAndIndividuals, getWarehouseProduct, searchBatchByCode, getTransportOrdersByBatchCode,
  getTransportOrdersByClientName, changeBatchDefectsAmount, getProductBatchFiltered, getAllWarehouseProducts,
  getBatchIndividuals, getKpiSummary, getInventoryByProduct, getDefectsByProduct,
  getDashboardSummary, getInventoryExpiry, getDefectsByMonthStats,
  searchPendingOrders, removeOrderFromTransport, addOrderToTransport };